import { useEffect, useRef, useState } from "react";
import FormDrawer from "components/__new/common/form-drawer";
import PinInput from 'react-pin-input';
import { toast } from "react-toastify";
import { ButtonLoader } from "./form";
import Maybe from "./Maybe";
import PageContent from "./PageContent";
import ResetAccessPin from "components/__new/common/access-pin/ResetAccessPin";


export const PinModal = (props) => {
    const {isOpenPin, setIsOpenPin} = props;
    const resetAccessPinRef = useRef();
    
    const pinLength = 4;
    const [pin, setPin] = useState("");
    let elementRef = useRef();
    

    const submitForm = async (e) => {
        e.preventDefault();
        if (pin !== "" && pin.length === pinLength){
            if(props.handleSubmit){
                props.handleSubmit(pin)
                clearInputPin();
            }
            return (props.submit && props.submit(pin));
        }
        else{
            toast.error("Please enter a valid " + props.target);
        }
    }

    const clearInputPin =() => {
        if (elementRef.currentIndex !== undefined){
            elementRef.clear();
            setPin("");
        }
    }

    useEffect(() => {
        clearInputPin();
    }, [isOpenPin]);
    
    // useEffect(() => {
    //     // elementRef.focus()
    //     console.log(elementRef)
    // }, []);

    return (
        <>
        
            <Maybe condition={props.showForgotPin === true}>
                <ResetAccessPin ref={resetAccessPinRef} />
            </Maybe>

            <FormDrawer display="center" size="sm" isOpen={isOpenPin} setIsOpen={setIsOpenPin} backdropClickable={false}>

                <Maybe condition={props.modalLoading === true}>
                    <div className="p-8">
                        <PageContent loading={props.modalLoading} />
                    </div>
                </Maybe>

                <Maybe condition={!props.modalLoading || props.modalLoading === false}>
                    <form onSubmit={submitForm} className="p-8">
                        <div>
                            <div className="text-xl font-bold">
                                {props.title}
                            </div>
                            <Maybe condition={props.description !== undefined}>
                                <div className="text-fade">
                                    {props.description}
                                </div>
                            </Maybe>
                        </div>

                        <div className="h-16 mt-14">
                            <PinInput 
                                length={pinLength} 
                                initialValue={pin}
                                // onChange={(value, index) => {setPin(value); props.pin(value)}} 
                                onChange={(value, index) => {setPin(value); props.pin && props.pin(value)}} 
                                type="numeric" 
                                inputMode="number"
                                inputStyle={{
                                    width: '50px',
                                    border: "2px solid #e5e7eb",
                                    fontSize: "28px",
                                    borderRadius: "10px",
                                    paddingTop: "2px"
                                }}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                                secretDelay={300}
                                inputFocusStyle={{border: "2px solid #e5e7eb"}}
                                onComplete={(value, index) => {}}
                                autoSelect={true}
                                focus={true}
                                secret={true}
                                ref={(n) => (elementRef = n)}
                            />
                        </div>
                        <Maybe condition={props.showForgotPin === true}>
                            <div className="mt-2 flex justify-end">
                                <div onClick={() => {setIsOpenPin(false); resetAccessPinRef.current?.initiateResetPin()}} className="text-ep-primary-600 font-medium underline cursor-pointer">
                                    Forgot Pin?
                                </div>
                            </div>
                        </Maybe>

                        <Maybe condition={props.footnote !== undefined}>
                            <div className="mt-2 relative top-6">
                                {props.footnote}
                            </div>
                        </Maybe>

                        <div className="mt-10 flex space-x-4 justify-end">
                            <button type="button" onClick={() => {setIsOpenPin(false); props.handleCancel && props.handleCancel()}} className="btn btn-transparent-primary">
                                Cancel
                            </button>
                            <ButtonLoader loading={props.loading} type="submit" className="btn btn-ep-primary">
                                Continue
                            </ButtonLoader>
                        </div>
                    </form>
                </Maybe>

            </FormDrawer>
        </>
    )
}

export default PinModal;
